import React from 'react';
import cssSummarize from '@/css/module/summarizeInline.css';
import AggregateFunction from '@/util/AggregateFunction';
import TableRef from '@/util/TableRef';
import {
  StepValue,
  StepValueAction,
} from '@/views/QueryBuilder/subcomponents/Steps';
import { TrevorIcon } from '@trevor/ui-components';

export type ChosenMetricProps = {
  aggregateFunction?: AggregateFunction;
  aliases: Record<string, TableRef>;
  onClick?: F<React.MouseEvent>;
  onDelete?: F0;
  editable?: boolean;
  showCustomName?: boolean;
};

export const ChosenMetric: React.FC<ChosenMetricProps> = ({
  aggregateFunction,
  aliases,
  onClick,
  onDelete,
  editable,
  showCustomName = true,
}) => {
  const columnName = aggregateFunction?.columnName();
  const deleteMetric = (e: React.MouseEvent) => {
    if (onDelete) {
      onDelete();
    }
    e.stopPropagation();
  };
  const hasConditions = !!aggregateFunction?.clauses;
  // if metric is for primary key (for now, this means it === 'id', display table name)
  const metricName = columnName
    ? columnName.name() === 'id'
      ? aggregateFunction?.toString([columnName], aliases)
      : aggregateFunction?.toString()
    : 'row count';
  const customName = aggregateFunction?.metricColumnName;

  const label =
    (showCustomName && customName ? customName : metricName) +
    (hasConditions && showCustomName ? '*' : '');

  return (
    <div className={cssSummarize.pillContainer}>
      <StepValue $type="summarise" onClick={onClick}>
        {label}
        {editable && (
          <StepValueAction>
            <TrevorIcon name="pen" />
          </StepValueAction>
        )}
        <StepValueAction onClick={deleteMetric}>
          <TrevorIcon name="close-small" />
        </StepValueAction>
      </StepValue>
    </div>
  );
};
